(function () {
	"use strict";

	angular.module("swurveys.maker")
		.controller("dashboardController", Handler);

	function Handler(
		$scope, $routeParams, $timeout, $location, $http,
		swurveyService, swurveyAdminService, loggedInUser, authService,
		swurveyTemplateService, createModal, deleteModal, shareModal, adminUpdateSwurveyModal,
		embedSwurveyModal, localStoreService
	) {

		var credential = loggedInUser;
		$scope.user = loggedInUser;

		var myUserId = credential.swurveys.identityId();
		var otherUserId = $routeParams.uid;

		if (otherUserId != myUserId) {
			$scope.firstName = "Another User";
			//We are looking at another user
			swurveyAdminService.getUser(otherUserId, function(err, data) {
				$scope.otherUser = data;
				$scope.firstName = data.name;
			});
		}

		//Fields --------------------------------------------------------------
		$scope.filters = {
			"name": "NAME",
			"-name": "NAME REVERSED",
			"-publicationDate": "DATE"
		};

		$scope.sort = {
			order: "-publicationDate",
			searchText: ""
		};

		//Methods -------------------------------------------------------------

		/**
		 * Loads review analytics for published swurveys
		 * @param publishedSwurveys Object containing a Swurvey ID and index
		 */
		var loadAnalyticsData = function (publishedSwurveys) {
			console.log("Loading analytics.....");
			for(var i = 0; i < publishedSwurveys.length; i++) {
				var swurvey = publishedSwurveys[i];
				var url = swurveyAdminService.getJSONLink(swurvey.id);
				$http.get(url)
					.then((function (index) {
						return function (response) {
							$scope.listResponse.swurveys[index].totalAttempts = response.data.TotalAttemptedCount || 0;
							$scope.listResponse.swurveys[index].totalResponses = response.data.TotalResponseCount || 0;
						};
					})(swurvey.index));
			}
		};

		/**
		 * Refreshes swurvey list. Called after deleting/publishing swurvey
		 */
		var refreshSwurveyList = function () {

			//Retrieve all user swurveys
			var userId = $routeParams.uid;
			var publishedSwurveys = [];

			if(!userId)
				userId = credential.swurveys.identityId();

			swurveyAdminService.listSwurveys(userId, function (err, data) {
				if(err || !data || !data.swurveys) {
					if(err.code == "ClientError") {
						//A user is trying to view a dashboard that isn't theirs
						//This commonly happens when a user logs out of one account and logs into another
						//Let's send them to their dashboard
			      return $timeout(function () {
							$location.path("/d/" + credential.swurveys.identityId());
						});
					}
					authService.relogin();
					return console.error(err, data);
				}

				// Get preview analytics
				for(var i = 0; i < data.swurveys.length; i++) {
					if(data.swurveys[i].state && data.swurveys[i].state != "New") {
						publishedSwurveys.push({
							id: data.swurveys[i].id,
							index: i
						});
					}
				}

				loadAnalyticsData(publishedSwurveys);

				$scope.$evalAsync(function () {
				  $scope.listResponse = data;
					$scope.zeroSwurveys = data.swurveys.length == 0;
				});
			});
    };

    var disableSwurvey = function(id) {
    	$scope.listResponse.swurveys[getSwurveyIndex(id)].class ='disabled-element';
    };

    var enableSwurvey = function(id) {
    	$scope.listResponse.swurveys[getSwurveyIndex(id)].class ='';
    };

    var removeSwurveyFromView = function(id) {
    	$scope.listResponse.swurveys.splice(getSwurveyIndex(id),1);
    };

    var getSwurveyIndex = function(id) {
      var swurveyIndex = $scope.listResponse.swurveys.findIndex(function(s) {
      	return s.id === id;
      });
      return swurveyIndex;
    }

		/**
		 * Opens the swurvey editor for a specific Swurvey
		 * @param id Target swurvey id
		 */
		$scope.editSwurvey = function(id) {
			$timeout(function () {
				$location.path("/e/" + id);
			});
		};

		/**
		 * Opens analytics page for a specific swurvey
		 * @param id Target swurvey id
		 */
		var viewAnalytics = function (id) {
			$timeout(function () {
				$location.path("/a/" + id + "/private");
			});
		};

		/**
		 * Opens share overlay
		 * @param swurvey Swurvey being shared
		 */
		$scope.openShareOverlay = function (swurvey) {
			shareModal.show(swurvey);
		};

		/**
		 * Opens modal for deleting a Swurvey
		 * @param id Target swurvey id
		 */
		$scope.delete = function (id) {
			deleteModal.show("Delete", "This will delete all data associated with this Swurvey from our system, including questions, answers, collected responses, and processed analytics.").then(function (modal) {
				modal.element.modal();
				modal.close.then(function (confirm) {
					if (confirm === true) {
					  disableSwurvey(id); //updates the view prior the server call.  Prevents the UI from seeing a lag response.
						swurveyAdminService.deleteSwurvey(id, function (err) {
							if (err) {
                $scope.listResponse.swurveys[getSwurveyIndex(id)].class = 'error';
								refreshSwurveyList();   //if the server returns an error from an attempted delete, refresh the swurvey list so it shows the actual list.
								return console.log(err);
							} else {
                $scope.$apply(removeSwurveyFromView(id));
              }
						});
					}
				});
			});
		};

		/**
		 * Opens modal for closing a Swurvey
		 * @param id Target swurvey id
		 */
		$scope.close = function (id) {
			deleteModal.show("Close", "This will close the swurvey. No more users will be able to take this Swurvey, but all your data will persist and you may clone this Swurvey.").then(function (modal) {
				modal.element.modal();
				modal.close.then(function (confirm) {
					if (confirm === true) {
					  disableSwurvey(id);
						swurveyAdminService.updateSwurveyState(id, "Closed", function (err) {
							if (err) {
								$scope.listResponse.swurveys[getSwurveyIndex(id)].class = 'error';
								refreshSwurveyList();
							} else {
                $scope.listResponse.swurveys[getSwurveyIndex(id)].state = 'Closed';
              }
							enableSwurvey(id);
						});
					}
				});
			});
		};

    $scope.cloneSwurvey = function(id) {
			disableSwurvey(id);
      var previousId = id; //needed because id becomes the cloned swurvey's id after calling createSwurvey.
			swurveyService.getModel(id, function(err, res) {
				if (err) {
					$scope.createSwurveyError = "Hey!  We're really sorry about this, but there was a problem creating your swurvey.  If the issue continues, let our admins know you got a" + err + "error.";
			  } else if (res && res.data) {
					var model = res.data;
					var name = model.name + " [Cloned]";
					swurveyAdminService.createSwurvey(name, model, function (err, res) {
            if (res) {
							refreshSwurveyList();
            } else {
            	if(err.code == 'CredentialsError') {
        				return authService.relogin();
            	}
              $scope.createSwurveyError = "Whoops!  While trying to create your swurvey we got a " + err + " error.  If you keep having this problem, write this error down and let our admins know!";
            }
					});
				}
			});
    };

		/**
		 * Opens modal for naming/creating a new Swurvey
		 */
		$scope.newSwurvey = function () {
    	swurveyTemplateService.getStandard(function (res) {
        var model = res.data;
        createModal.show(model);
	    });
		};

		$scope.adminUpdateSwurvey = function(swurvey) {
			adminUpdateSwurveyModal.show(swurvey, loggedInUser.user).then(function (modal) {
				modal.element.modal();
        modal.close.then(function (shouldReload) {
        	if(shouldReload) {
        	  refreshSwurveyList();
        	}
        });
			});
		};

		$scope.adminResetSwurveyData = function(swurvey) {
			deleteModal.show("Reset Data", "This will reset the swurvey data. This will delete all processed aggregates, as well as individually recorded responses.").then(
				function (modal) {
					modal.element.modal();
					modal.close.then(function (confirm) {
						if (confirm === true) {
							swurveyAdminService.resetSwurveyData(swurvey.id, function() {
								refreshSwurveyList();
							});
						}
					});
				});
		};

		/**
		 * Executes the best action given the state of a Swurvey
		 * @param swurvey Swurvey to evaluate
		 */
		$scope.mainAction = function (swurvey) {
			if (swurvey.state === "New") {
				$scope.editSwurvey(swurvey.id);
			} else {
				if (!swurvey.totalResponses || swurvey.totalResponses === 0) {
					$scope.openShareOverlay(swurvey);
				} else {
					viewAnalytics(swurvey.id);
				}
			}
		};

		$scope.getTierHelp = function(tier) {
			if(tier == "Free") {
				return "This is a free Swurvey. Share it will everyone!";
			}
			if(tier == "Feedback") {
				return "This is a Feedback Swurvey. Each completed response will cost you 1SC. That means you have enough credits to receive " +  loggedInUser.user.accountBalance + " more responses";
			}
			if(tier == "FeedbackPlus") {
				return "This is a Feedback Plus Swurvey. Each completed response will cost you 3SC. That means you have enough credits to receive " +  Math.floor(loggedInUser.user.accountBalance  /3)+ " more responses";
			}
			if(tier == "Engagement") {
				return "This is an Engagement Swurvey. Each completed response will cost you 5SC. That means you have enough credits to receive " +  Math.floor(loggedInUser.user.accountBalance / 5)+ " more responses";
			}
		};

		// Only list swurveys if is logged in
		if(credential.isLoggedIn()) {
			refreshSwurveyList();
			if (loggedInUser && loggedInUser.user && loggedInUser.user.name) {
				$scope.firstName = loggedInUser.user.name.split(" ")[0];
			}
			else {
				console.error("User doesn't have a name! ", loggedInUser);

			}
			if (!localStoreService.getItem("dashboardTourV1")) {
				embedSwurveyModal.show("a8f9640b5f02434c9b22f620f3bf3ff4", loggedInUser.user.email);
				localStoreService.setItem("dashboardTourV1", true);
			}
		}
	}
}());
